import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslateUnauthenticatedPipe } from '../../filters/translate-unauthenticated.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-form-error-with-translator',
	templateUrl: './item-form-error-with-translator.component.html',
	imports: [ CommonModule, LowerCasePipe, TranslateUnauthenticatedPipe, FormsModule ]
})
export class ItemFormErrorWithTranslatorComponent implements OnInit {
	
	@Input() fieldName: any;
	@Input() noOffset: any | undefined;
	@Input() error: any;
	
	vm: any = undefined;
	
	constructor() {}
	
	ngOnInit() {
		
	}
	
	getErrors() {
		if (!this.error) {
			return [];
		}
		if (!Array.isArray(this.error)) {
			this.error = [this.error];
		}
		return this.error;
	}
	
}